const isDataNoResults = (data) => !!data && !data.length;

export default isDataNoResults;
